import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CrawfordDropDownComponent, CrawfordSnackbarService, SearchOperatorsConfig } from 'crawford-shell';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserDetails } from '../../../user/user-details.model';
import { UserService } from '../../../user/user.service';
import { AccordionService } from '../services/accordion.service';


@Component({
  selector: 'app-claim-ref-search',
  templateUrl: './claim-ref-search.component.html',
  styleUrls: ['./claim-ref-search.component.scss']
})
export class ClaimRefSearchComponent
  implements OnInit {

  @Input() public group: FormGroup;
  @Input() searchOperatorsConfig: SearchOperatorsConfig;
  @Output() public criteria: {
    referenceType: string,
    reference: string,
    includeLinked: boolean,
    includeArchived: boolean,
  };

  @ViewChild('advancedSearchReferenceOperator') private referenceOperator: CrawfordDropDownComponent;

  public controlsReady: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public userDetails: UserDetails;
  public searchOperators: any;
  @Input() public accordionGroupName: string; // = 'reference';

  public references = [
    { name: 'Crawford Reference', id: 1 },
    { name: 'Claim Number', id: 2, },
    { name: 'Policy Number', id: 3, },
    { name: 'Broker Reference', id: 4, }
  ];

  constructor(
    public snackbarService: CrawfordSnackbarService,
    private userService: UserService,
    private accordionService: AccordionService
  ) {
  }

  ngOnInit() {
    ['referenceSearch', 'includeLinked']
      .forEach(name => this.accordionService.addFormControl(this.accordionGroupName, this.group, name));

    ['references', 'referenceSearchOperator']
      .forEach(name => this.group.addControl(name, new FormControl()));

    this.userDetails = this.userService.userDetails;
    if (this.searchOperatorsConfig) {
      this.configureSearchOperators(this.searchOperatorsConfig.operators, this.searchOperatorsConfig.defaultValue);
    }
    this.group.controls.references.setValue(1); // default to crawford reference
    this.controlsReady.next(true);
    this.accordionService.setAccordionHasChanges(this.accordionGroupName, false);
  }

  public configureSearchOperators(operators: any, defaultValue: any): void {
    if (operators) {
      this.searchOperators = operators;

      this.setOperatorValue(defaultValue);
    }
  }

  public setOperatorValue(defaultValue: any) {
    if (!this.group.controls['referenceSearchOperator']) {
      this.group.addControl('referenceSearchOperator', new FormControl());
    }
    this.group.get('referenceSearchOperator').setValue(defaultValue);
  }

  public checkHasComma(event: any) {
    if (this.referenceOperator) {
      if (event.referenceSearch && event.referenceSearch.indexOf(',') > -1) {
        this.referenceOperator.setEnabled(false);
        this.setOperatorValue(0);
      } else {
        this.referenceOperator.setEnabled(true);
      }
    }
  }

  public resetSearchTypeDropdown() {
    this.referenceOperator.setEnabled(true);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-list/claim-ref-search/claim-ref-search.component.ts